import { useQuery } from '@tanstack/react-query';
import { useApi } from '@issuemanager/api-client';
import {
  ExtendedAxiosError,
  useAppConfig,
} from '@issuemanager/apps/client/hooks';
import { type SubdomainSession } from '@acl-services/jwt-highbond-middleware';
import { localSession } from './localSession';

export function useSession() {
  const api = useApi();
  const appConfig = useAppConfig();

  return useQuery<SubdomainSession, ExtendedAxiosError>({
    queryKey: ['highbond-session'],
    queryFn: () => {
      if (appConfig.isLocalDev) {
        return Promise.resolve(localSession as unknown as SubdomainSession);
      } else {
        return api.axios
          .get<SubdomainSession>(appConfig.sessionUrl)
          .then((r) => r.data);
      }
    },
    retry: 2,
    retryDelay: 1000,
  });
}
